// extracted by mini-css-extract-plugin
module.exports = {"container":"embed_container_3WmHh","bodyContainer":"embed_bodyContainer_29jpW"};